namespace SPA
{
	export namespace BWS
	{
		export namespace data
		{

			export class BWSTableDataModel
				extends ui.table.model.AbstractTableModel<Wollmilch.BWS.IBWS>
			{

				public constructor( descriptor?: ui.table.model.ITableModelDescriptor )
				{
					super( descriptor );

					this.ModelReader( new BWSTableDataReader() );
				}

				public buildHeader(): JQuery<HTMLElement>
				{
					return new ui.base.BaseHTMLElement( 'tr' )
						.append( new ui.base.BaseHTMLElement( 'th' ).append( app.getMessage( 'BWS.TABLE.ObjectNumber' ) ) )
						.append( new ui.base.BaseHTMLElement( 'th' ).append( app.getMessage( 'BWS.TABLE.ObjectAddress' ) ) )
						.append( new ui.base.BaseHTMLElement( 'th' ).append( app.getMessage( 'BWS.TABLE.CaseNumber' ) ) )
						.append( new ui.base.BaseHTMLElement( 'th' ).append( app.getMessage( 'BWS.TABLE.created_at' ) ) )
					.Root();
				}

			}

		}
	}
}
